module.exports = __webpack_public_path__ + "img/animalone.866858a3.png";